import { Controller } from 'stimulus';

/**
 * Auto-clicks the element when the page is loaded with a specific URL
 * parameter set to an expected value. The parameter name is configurable via
 * the `param` value; the expected value via the `expected` value, which
 * defaults to "true".
 *
 * @example
 *   <a data-controller="auto-click"
 *      data-auto-click-param-value="submit_flow"
 *      href="...">Submit Entry</a>
 *
 * @example
 *   <a data-controller="auto-click"
 *      data-auto-click-param-value="modal"
 *      data-auto-click-expected-value="send"
 *      href="...">Send Invoice</a>
 */
export default class extends Controller {
  static values = { param: String, expected: { type: String, default: 'true' } };

  connect() {
    if (!this.#shouldAutoClick()) {
      return;
    }

    this.#cleanUpUrl();
    requestAnimationFrame(() => this.element.click());
  }

  #shouldAutoClick() {
    return new URLSearchParams(window.location.search).get(this.paramValue) === this.expectedValue;
  }

  #cleanUpUrl() {
    const url = new URL(window.location.href);
    url.searchParams.delete(this.paramValue);
    window.history.replaceState({}, '', url);
  }
}
